// ALL CONSTANTS
export const STORAGE_KEY = 'jwtToken'
